import type { CloudConnectAddress } from 'src/api/endpoints/cloudConnect.types';

import type { CheckoutFormState } from '../components/Checkout.types';

export const checkoutAddressFields = [
  'country',
  'state',
  'province',
  'billingAddress1',
  'billingAddress2',
  'postalCode',
  'city',
] satisfies (keyof CheckoutFormState)[];

export const toCheckoutAddress = (
  form: CheckoutFormState
): CloudConnectAddress => {
  if (!form.country) {
    throw new Error('Country is required for checkout.');
  }

  return {
    country: form.country,
    state:
      form.country === 'CA'
        ? form.province
        : form.country === 'US'
          ? form.state
          : undefined,
    line1: form.billingAddress1,
    line2: form.billingAddress2,
    postalCode: form.postalCode,
    city: form.city,
  };
};
